export default __webpack_public_path__ + "static/media/Collar of Havoc.fca1c20e.jpg";